import { Contact } from "./Contact";
import { Customer } from "./Customer";

export class AuthorizationData {
    EMSToken = "";
    EMSusername = "";
    username = "";
    securityToken = "";
    tokenClaimDate = "";
    customer: Customer = new Customer();
    contact: Contact = new Contact();
    userType = 0;
}
